import React, { useEffect, useRef, useState } from "react";
import { Button } from "@material-ui/core";
import * as authActions from "app/auth/store/actions";
import { useDispatch, useSelector } from "react-redux";
// import { Form } from "react-final-form";
import Formsy from "formsy-react";
import { TextFieldFormsy } from "@fuse";
// import createDecorator from "final-form-focus";
// import _ from "lodash";

// import {
// 	composeValidators,
// 	emailAvailable,
// 	emailValidator,
// 	nickAvailable,
// 	passwordCheckValidator,
// 	passwordValidator,
// 	requiredValidator,
// 	specialCharValidator,
// } from "app/services/validator";
// import InputAdapter from "app/main/components/InputAdapter";

// const focusOnError = createDecorator();

function RegisterBox(props) {
	const dispatch = useDispatch();
	const register = useSelector(({ auth }) => auth.register);

	const formRef = useRef(null);
	const [isFormValid, setIsFormValid] = useState(false);

	useEffect(() => {
		if (
			register.error &&
			(register.error.username ||
				register.error.password ||
				register.error.email)
		) {
			console.log("register.error: ", register.error);

			formRef.current.updateInputsWithError({
				...register.error,
			});
			// disableButton();
		}
	}, [register.error]);

	function onSubmit(model) {
		dispatch(authActions.registerWithFirebase(model));
		// dispatch(authActions.submitRegister(model));
	}
	function disableButton() {
		setIsFormValid(false);
	}

	function enableButton() {
		setIsFormValid(true);
	}

	return (
		<div className="w-full">
			<Formsy
				onValidSubmit={onSubmit}
				onValid={enableButton}
				onInvalid={disableButton}
				ref={formRef}
				className="flex flex-col justify-center w-full"
			>
				<TextFieldFormsy
					className="mb-16"
					type="text"
					name="displayName"
					label="이름"
					validations={{
						minLength: 2,
					}}
					validationErrors={{
						minLength: "최소 2자 이상입니다.",
					}}
					variant="outlined"
					required
				/>
				<TextFieldFormsy
					className="mb-16"
					type="text"
					name="email"
					label="이메일"
					validations={{
						isEmail: true,
					}}
					validationErrors={{
						isEmail: "올바른 이메일 형식이 아닙니다.",
					}}
					variant="outlined"
					required
				/>

				<TextFieldFormsy
					className="mb-16"
					type="password"
					name="password"
					label="비밀번호"
					validations={{ minLength: 8 }}
					validationErrors={{
						minLength: "최소 8자 이상입니다.",
					}}
					variant="outlined"
					required
				/>
				<TextFieldFormsy
					className="mb-16"
					type="password"
					name="confirm"
					label="비밀번호 확인"
					validations={{ minLength: 8, equalsField: "password" }}
					validationErrors={{
						equalsField: "비밀번호가 맞지 않습니다.",
						minLength: "최소 8자 이상입니다.",
					}}
					variant="outlined"
					required
				/>

				<Button
					type="submit"
					variant="contained"
					color="primary"
					className="w-full mx-auto mt-16 normal-case"
					aria-label="LOG IN"
					disabled={!isFormValid}
					value="legacy"
				>
					관리자 가입
				</Button>
			</Formsy>
			{/* <Form
				ref={formRef}
				onSubmit={onSubmit}
				decorators={[focusOnError]}
				render={({ handleSubmit, submitting, pristine, errors, values }) => (
					<form onSubmit={handleSubmit} className="flex flex-col space-y-3">
						<InputAdapter
							validator={composeValidators(
								requiredValidator,
								specialCharValidator
								// nickAvailable
							)}
							spinner="true"
							name="displayName"
							type="text"
							title="닉네임*"
							className="mb-5"
						/>
						<InputAdapter
							validator={composeValidators(
								requiredValidator,
								emailValidator
								// emailAvailable
							)}
							spinner="true"
							name="email"
							type="email"
							title="이메일*"
							className="mb-5"
						/>
						<InputAdapter
							validator={composeValidators(
								requiredValidator,
								passwordValidator
							)}
							name="password"
							type="password"
							title="비밀번호*"
							className="mb-5"
						/>
						<InputAdapter
							validator={composeValidators(
								requiredValidator,
								passwordValidator,
								passwordCheckValidator
							)}
							name="confirm"
							type="password"
							title="비밀번호 확인*"
							className="mb-10"
						/>
						<Button
							type="submit"
							color="primary"
							variant="contained"
							disabled={
								submitting ||
								Object.keys(errors).length !== 0 ||
								pristine ||
								errors.length > 0
							}
							fullWidth={true}
						>
							이메일로 회원가입
						</Button>
					</form>
				)}
			/> */}
		</div>
	);
}

export default RegisterBox;
